import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useState } from 'react';

export default function LanguageSelector({
  locale: initialLocale,
  localesSupported = [],
  onChange = () => undefined,
}) {
  const [locale, setLocale] = useState(initialLocale);

  const handleChange = (event, newLanguage) => {
    setLocale(newLanguage);
    onChange(event, newLanguage);
  };

  if (localesSupported?.length > 1) {
    return (
      <ToggleButtonGroup
        size="small"
        color="primary"
        value={locale}
        exclusive
        onChange={handleChange}>
        {localesSupported.map(item => (
          <ToggleButton key={item} value={item}>
            {item}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  }
  return null;
}
